import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

async function uploadBlobPDF(pdf, path) {
  try {
    if (!(pdf instanceof Blob)) {
      throw new Error("uploadPDF attend un Blob");
    }

    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, pdf, {
      contentType: "application/pdf",
    });

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snap) => {
          console.log(`${snap.bytesTransferred} / ${snap.totalBytes}`);
        },
        reject,
        async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(url);
        },
      );
    });
  } catch (err) {
    console.error("uploadPDF error:", err);
    throw err;
  }
}

export default uploadBlobPDF;
